module.exports = __webpack_public_path__ + "static/media/Missing You.42924be8.jpg";